import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "12",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M2.606 11.191h10.788c1.443 0 2.612-1.27 2.606-2.846V3.25c0-1.57-1.163-2.846-2.606-2.846H2.606C1.17.405 0 1.675 0 3.25v5.094c0 1.57 1.163 2.846 2.606 2.846m3.686-8.088 4.538 2.616-4.538 2.617z",
      "clip-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render: render }